import { useGetAccountsQuery } from '../../redux/api/fymAPI';
import { useAccountId, useUserToken } from '../../redux/slices/appInfo/hooks';

/**
 * True while the active artist is the read-only demo artist (LaziiBee). Screens use it to disable
 * obvious create and edit buttons. A write that gets through answers 403 `M24_DEMO_READ_ONLY`,
 * and `dispatchM24LimitPrompt` shows it as a toast.
 */
export function useIsDemoAccount(): boolean {
  const userToken = useUserToken();
  const activeAccountId = useAccountId();
  const { isDemo } = useGetAccountsQuery(undefined, {
    skip: !userToken,
    selectFromResult: ({ data }) => ({
      isDemo: data?.accounts.find((account) => account.id === activeAccountId)?.isDemo === true,
    }),
  });
  return isDemo;
}
